import React, { useEffect } from 'react';
import { toast } from 'sonner';
import { Toaster } from 'app/javascript/components/ui/toaster';

type Props = {
  toastMessage?: string | null;
  notice?: string | null;
  alert?: string | null;
};

const Toast = ({ toastMessage, notice, alert }: Props): React.ReactNode => {
  useEffect(() => {
    if (toastMessage) toast(toastMessage);
    if (notice) toast(notice);
    if (alert) toast.error(alert);
  }, []);

  return <Toaster />;
};

export default Toast;
